export const appThemes = {
  Primary: 0,
  Secondary: 1, //Red
  Third: 3, //Green
  Dark: 4,
  Indigo: 5,
  Ocean: 6,
  Night: 7,
  Platinum: 8,
  Iron: 9,
  Ukraine: 10,
};
